// extracted by mini-css-extract-plugin
export var messageSideLeft = "_na-1";
export var messageSideRight = "_na-2";
export var orderLookupBubbleContainer = "_na-0";
export var submitButton = "_na-3";